import { Box, IconButton, Stack, Typography } from '@mui/material';

import { pluralize } from 'appUtils';
import FontAwesomeIcon from 'features/common/FontAwesomeIcon';

/** custom icons */
import { ReactComponent as FirstPage } from './icons/first_page.svg';
import { ReactComponent as LastPage } from './icons/last_page.svg';

import styles from './PaginationFootter.module.css';

interface IPaginationFooter {
  page: number;
  setPage: (p: number) => void;
  pageCount: number;
  allCount: number;
  currCount: number;
}

/** custom pagination component - could be reused elsewhere (MUI implementation is very different) */
export default function PaginationFooter({
  currCount,
  allCount,
  page,
  setPage,
  pageCount,
}: IPaginationFooter) {
  const handlePage = (val: number) => {
    setPage(Math.max(1, Math.min(val, pageCount)));
  };

  return (
    <Box className={styles.paginationWrapper}>
      <Typography pl={1} variant="caption" position="absolute">
        {currCount} {pluralize(currCount, 'item')} on page
      </Typography>
      <Box className={styles.paginationNav}>
        <IconButton size="small" onClick={() => handlePage(1)}>
          <FirstPage />
        </IconButton>
        <IconButton size="small" onClick={() => handlePage(page - 1)}>
          <FontAwesomeIcon name="chevron-left" />
        </IconButton>
        <Stack className={styles.paginationPageInfo}>
          <Typography variant="caption">
            {allCount} {pluralize(allCount, 'Notification')}
          </Typography>
          <Typography variant="caption">
            Page {page} of {pageCount}
          </Typography>
        </Stack>
        <IconButton size="small" onClick={() => handlePage(page + 1)}>
          <FontAwesomeIcon name="chevron-right" />
        </IconButton>
        <IconButton size="small" onClick={() => handlePage(pageCount)}>
          <LastPage />
        </IconButton>
      </Box>
    </Box>
  );
}
